export default __webpack_public_path__ + "static/media/icon_user.5ab2cbd3.svg";